module.exports = __webpack_public_path__ + "img/logo_footer.72fd2f54.webp";